import { useEffect } from 'react';
import { useLocation } from 'react-router';

import Telemetry from '../services/telemetry/telemetry';

export default function RouteTelemetry() {
  const location = useLocation();

  useEffect(() => {
    Telemetry.log({
      eventName: 'react-router.route-changed',
      eventSource: 'ReactRouter',
      eventDescription: `Route changed to: ${location.pathname}`,
      eventData: {
        location,
      },
    });
  }, [location]);

  return null; // This component doesn't render anything
}
